import React, { FC } from "react";
import { List } from "immutable";
import { connect } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";
import injectReducer from "../../reduxFolder/injectReducer";
import warehouseReducer from "../../reduxFolder/reducers/warehouse";
import {
  warehouseSelectBranches,
  warehouseSelectBranchesLoading,
} from "../../reduxFolder/selectors/warehouseSelectors";
import { WarehouseBranchMap } from "../../types/api/warehouse";
import {
  StorageBranchesSpinner,
  StorageBranchesSpinnerWrapper,
} from "./Storage.styles";

interface StorageBranchesProps {
  isLoading: boolean;
  warehouseBranches: List<WarehouseBranchMap>;
}

const StorageBranches: FC<StorageBranchesProps> = React.memo(
  ({ warehouseBranches, isLoading }) => {
    const location = useLocation();

    if (isLoading) {
      return (
        <StorageBranchesSpinnerWrapper>
          <StorageBranchesSpinner isActive />
        </StorageBranchesSpinnerWrapper>
      );
    }

    if (warehouseBranches && warehouseBranches.size) {
      return (
        <Navigate
          to={`/parcels/${warehouseBranches.get(0)?.get("id")}`}
          state={location.state}
        />
      );
    }
  },
);

const withReducer = injectReducer({
  key: "warehouse",
  reducer: warehouseReducer,
});

const withConnect = connect(
  createStructuredSelector({
    warehouseBranches: warehouseSelectBranches,
    isLoading: warehouseSelectBranchesLoading,
  }),
  {},
);

const enhance = compose(withReducer, withConnect);

export default enhance(StorageBranches);
